import { render, staticRenderFns } from "./Composition.vue?vue&type=template&id=2265ee3e&scoped=true&"
import script from "./Composition.vue?vue&type=script&lang=js&"
export * from "./Composition.vue?vue&type=script&lang=js&"
import style0 from "./Composition.vue?vue&type=style&index=0&id=2265ee3e&lang=scss&scoped=true&"
import style1 from "./Composition.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265ee3e",
  null
  
)

export default component.exports